(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingSpecialServices',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var i        = 0;
		var checked  = $('.services').data('checked');

		$('form.services :checkbox').click(function checkboxClick(e) {
			var $self                   = $(this);
			var index                   = $self.prop('id').split(/-/)[1] + '-' + $self.prop('id').split(/-/)[2];
			var passenger               = parseInt($self.prop('id').split(/-/)[2]);
			var passenger_checked_count = getPassengerCheckedCt($('.special-service:checked'), passenger);

			if (passenger_checked_count === 5) {
				// we are putting this limit in, because TT can only return 4 special services within cruiseimportbooking.pl for some vendors.
				// rather than have different limits per CL, we are going to do 4 across the board. If this becomes an issue, we'll cross
				// that bridge when we come to it and adjust in a different way
				Adzuki.StatusMessage(
					'warning',
					'A maximum of 4 special services may be selected per guest. Pre-Paid Gratuities will not be included in this count.',
					'Alert'
				);
				e.preventDefault();
				return;
			}

			cruiseBookingCheckService(index);
		});

		for (i = 0; i < checked.length; i++) {
			$('#cell-' + checked[i]).prop('checked', true);
			cruiseBookingCheckService(checked[i]);
		}

		function cruiseBookingCheckService(index, skipAvailCheck) {
			var indexChunks  = null;
			var serviceIndex = null;

			if ($('#cell-' + index).prop('checked')) {
				$('#cell-d-' + index).prop('disabled', false);
				$('#cell-y-' + index).prop('disabled', false);
			} else {
				indexChunks    = index.split(/-/);
				serviceIndex   = indexChunks[0];

				if ($('#rbcl-' + serviceIndex).val() !== '1') {
					$('#cell-' + index).prop('checked', true);

					Adzuki.CustomConfirm({
						title  : 'Special service no longer available',
						content: 'This special service is no longer being offered by the cruise line.  If you remove it, you may<br />not be able to re-add to the booking at a later time.  Are you sure you want to remove it?',
						confirm: function confirm() {
							$('#cell-' + index).prop('checked', false);
							$('#cell-d-' + index).prop('selectedIndex', 0);
							$('#cell-y-' + index).prop('selectedIndex', 0);
							$('#cell-d-' + index).prop('disabled', true);
							$('#cell-y-' + index).prop('disabled', true);
							return true;
						}
					});

					return;
				}

				$('#cell-d-' + index).prop('selectedIndex', 0);
				$('#cell-y-' + index).prop('selectedIndex', 0);
				$('#cell-d-' + index).prop('disabled', true);
				$('#cell-y-' + index).prop('disabled', true);
			}

			return;
		}

		function getPassengerCheckedCt($checked_special_services, psg_num) {
			var ct = 0;

			// loop thru special services
			$checked_special_services.each(function lp( index ) {
				// check the passenger number
				if ($(this).data("passenger") === psg_num) {
					ct++;
				}
			});

			return ct;
		}
	};
}(jQuery, window.Adzuki || {}));
